import type { PhaseReturn } from "../../../common/types.ts";

const newPhaseAfterTradeDeadline = async (): Promise<PhaseReturn> => {
	return {};
};

export default newPhaseAfterTradeDeadline;
